import { render, staticRenderFns } from "./CopyStakeJackpotCampaignDialog.vue?vue&type=template&id=55395f64&scoped=true&lang=pug"
import script from "./CopyStakeJackpotCampaignDialog.vue?vue&type=script&lang=ts"
export * from "./CopyStakeJackpotCampaignDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeJackpotCampaignDialog.vue?vue&type=style&index=0&id=55395f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55395f64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardActions,VProgressLinear,VSpacer})
